import ForgotPasswordForm from "../../components/auth/forms/ForgotPasswordForm";

const ForgotPasswordPage = () => {
    return <ForgotPasswordForm/>
};

export default ForgotPasswordPage;
